import CronExpressionParser from 'cron-parser';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(utcPlugin);
dayjs.extend(relativeTimePlugin);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default dayjs;

export function convertToUtcDate(date: dayjs.ConfigType) {
  const dayjsDate = dayjs.utc(date);

  return dayjs(
    new Date(
      dayjsDate.year(),
      dayjsDate.month(),
      dayjsDate.date(),
      dayjsDate.hour(),
      dayjsDate.minute(),
      dayjsDate.second(),
      dayjsDate.millisecond(),
    ),
  );
}

export function getTimeElapsed(date1: dayjs.ConfigType, date2: dayjs.ConfigType) {
  return dayjs.duration(dayjs(date1).diff(dayjs(date2)));
}

export function isValidCronExpression(value: string) {
  try {
    CronExpressionParser.parse(value);

    return true;
  } catch {
    return false;
  }
}

/**
 * Get the short timezone string (e.g. "EDT", "CDT", "MDT", etc.)
 * use en-GB locale to get the short timezone string properly as opposed to GMT+X
 * If i18n API fails, use dayjs to get the timezone
 * @returns {string} The short timezone string
 */
export const getShortTimeZone = () => {
  const dayJsTimezone = dayjs.tz.guess();

  return (
    new Intl.DateTimeFormat('en-GB', { timeZoneName: 'short' })
      .formatToParts()
      .find((part) => part.type === 'timeZoneName')?.value ?? dayjs().tz(dayJsTimezone).format('z')
  );
};
